<template>
  <div class="tab">
    <ul class="tab__items">
      <li v-for="item in items" :key="item.slug" class="tab__item">
        <button @click="setTab(item.slug)" :class="tab === item.slug && 'is-current'">{{ item.name }}</button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data: function () {
    return {
      items: [
        { slug: 'shirts', name: 'シャツ' },
        { slug: 'pants', name: 'パンツ' },
        { slug: 'cap', name: 'キャップ' },
        { slug: 'emblem', name: 'エンブレム' },
        { slug: 'mark', name: 'マーク' },
      ]
    }
  },
  computed: {
    ...mapState({
      tab: state => state.current.tab,
    })
  },
  methods: {
    ...mapMutations({
      setTab: 'current/setTab'
    })
  }
}
</script>